/*
 * 小鱼云镜
 */
import React from 'react';
import cn from 'classnames';
import Scheme from 'components/product/scheme';
import TabPanel from 'components/product/tabPanel';
import Contact from 'components/contact';
import Transition from 'components/transition';
import { WrapperBanner } from 'components/product/banner';
import Wrapper from 'components/product/relevance/wrapper';
import MultipleBanner from 'components/product/banner/multiple';
import style from './index.module.scss';

const IMG_PRE = 'https://sdk-source.xylink.com/website/assets/hardware/cloud/mirror/';
const tabList = [
  {
    title: '沉浸体验',
    name: '画面逼真，身临其境',
    desc: '等比还原现场画面，自然眼神对视，沉浸视野纵\n览全局\n支持声像同位，可设置站立模式，针对不同场景\n灵活适配需求',
    mDesc: '等比还原现场画面，自然眼神对视，沉浸视野\n纵览全局\n支持声像同位，可设置站立模式，针对不同场\n景灵活适配需求',
    imgUrl: IMG_PRE + 'feature-img0.jpg',
  },
  {
    title: '会控会管',
    name: '操作灵活，简单易用',
    desc: '11.6英寸触屏会议终端化身专业控制台\n拥有丰富的本地和会议控制功能',
    imgUrl: IMG_PRE + 'feature-img1.jpg',
  },
  {
    title: 'AI应用',
    name: '同传字幕，人物识别',
    desc: '会议中语音自动生成字幕\n快速识别是否有与会者，实时调整系统状态',
    imgUrl: IMG_PRE + 'feature-img2.jpg',
  },
  {
    title: '智能会议室',
    name: '触屏操作，智能监控',
    desc: '控制台集中控制会议室灯光、空调、窗帘等设备\n灵动便捷实现全流程智能会议体验',
    mDesc: '控制台集中控制会议室灯光、空调、窗帘等设备灵动便捷实现全流程智能会议体验',
    imgUrl: IMG_PRE + 'feature-img3.jpg',
  },
];
const scene = [
  {
    title: '高端沉浸式会议',
    pcUrl: IMG_PRE + 'scene-img4.jpg',
  },
  {
    title: '领导指挥舱',
    pcUrl: IMG_PRE + 'scene-img5.jpg',
  },
  {
    title: '高品质学习培训',
    pcUrl: IMG_PRE + 'scene-img3.jpg',
  },
  {
    title: '远程会诊',
    pcUrl: IMG_PRE + 'scene-img2.jpg',
  },
];
const bannerList = [
  {
    mUrl: IMG_PRE + 'm/bgM-image1.jpg',
    pcUrl: IMG_PRE + 'banner0.jpg',
    title: '小鱼云镜沉浸式远真',
    mTitle: '小鱼云镜\n沉浸式远真',
    desc: '高端沉浸式云视频多屏远真\n现场远端画面1:1高清呈现，畅享身临其境会议体验',
    mDesc: '高端沉浸式云视频多屏远真\n现场远端画面1:1高清呈现，畅享身临其境会议\n体验',
    isMCenter: true,
    className: style.banner1,
  },
  {
    mUrl: IMG_PRE + 'm/bgM-image2.jpg',
    pcUrl: IMG_PRE + 'banner1.jpg',
    title: '高度集成，一体交付',
    desc: '高度集成视频终端、摄像机、显示屏、麦克风、音箱\n与触控台设备、灯光、家具及装修设计一体化交付部署',
    mDesc: '高度集成视频终端、摄像机、显示屏、麦克\n风、音箱\n与触控台设备、灯光、家具及装修设计一体化\n交付部署',
  },
  {
    mUrl: IMG_PRE + 'm/bgM-image3.jpg',
    pcUrl: IMG_PRE + 'banner2.jpg',
    title: '如临现场，细致入微',
    desc: '48:9双4K画面，真人1:1呈现，声像同位如临现场',
  },
  {
    mUrl: IMG_PRE + 'm/bgM-image4.jpg',
    pcUrl: IMG_PRE + 'banner3.jpg',
    title: '灵活布局，兼容应用',
    desc: '屏幕布局和画面自由定制，满足不同场景的个性化显示需求\n灵活接入各种视频会议终端、监控、无人机、单兵设备、智能头盔和眼镜等',
    mDesc: '屏幕布局和画面自由定制，满足不同场景的个\n性化显示需求\n灵活接入各种视频会议终端、监控、无人机、\n单兵设备、智能头盔和眼镜等',
  },
];
const scheme = [
  { title: '单排场景', pcUrl: IMG_PRE + 'scene-img0.jpg' },
  { title: '双排场景', pcUrl: IMG_PRE + 'scene-img1.jpg' },
];
const Mirror = () => {
  return (
    <Wrapper title="小鱼云镜" menuIndex="2" current={1} customClass={style.mirror}>
      {bannerList.map((item: any) => {
        return <MultipleBanner animate={'fadeIn'} delay={0.5} {...item} descCenter type={2} key={item.title} className={cn(style.banner, item.className)} />;
      })}
      <TabPanel list={tabList} title={'功能特色'} className={style.feature} />
      <WrapperBanner
        bannerInfo={{
          pcUrl: IMG_PRE + 'banner4.jpg',
          mUrl: IMG_PRE + 'm/bgM-image0.jpg',
          classNames: style.scheme,
        }}
      >
        <div className={style['scheme-content']}>
          {scheme.map((item: any) => {
            return (
              <div key={item.title} className={style['scheme-item']}>
                <Transition>
                  <p className={style['scheme-item-title']}>{item.title}</p>
                </Transition>
                <Transition>
                  <img className={'for-pc'} src={item.pcUrl} alt="" />
                </Transition>
                <Transition>
                  <img className={'for-mobile'} src={item.pcUrl} alt="" />
                </Transition>
              </div>
            );
          })}
        </div>
      </WrapperBanner>
      <Scheme animate={'fadeIn'} delay={0.5} data={scene} title={'应用场景'} className={style.scene} type={3} />
      <Contact className={style.contact} btnType={'newBtn'} />
    </Wrapper>
  );
};

export default Mirror;
